import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

/**
 * Anon-key client. Used for Realtime subscriptions + RLS-scoped reads.
 * The FicoPilot backend bridges the FastAPI session → Supabase session via
 * /api/supabase/session, which calls setSession() on this instance.
 *
 * The service_role key NEVER appears in this file or the frontend bundle.
 */
export const supabase = SUPABASE_URL && SUPABASE_ANON_KEY
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        storageKey: "fp-supabase-auth",
      },
      realtime: { params: { eventsPerSecond: 5 } },
    })
  : null;

export const supabaseReady = Boolean(supabase);
